import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/_services/api.service';
import { AuthService } from 'src/app/_services/auth.service';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {

  LanguageId: number = 0
  CountryCode: string = "";
  PolicyPrivacyText: SafeHtml;
  customStyle: string;

  constructor(
    public router: Router,
    private apiService: ApiService,
    private sanitizer: DomSanitizer,
    private authService: AuthService,
  ) {
    this.customStyle = "<style>h2,h3,h4 {color: var(--app-brand-cyan) !important;}</style>"
    authService.changeLangPrivacyPolicyEventEmitter.subscribe(response =>{
      if(response){
        this.getPrivacyPolicy();
      }
    })
    this.authService.hideNavigationMenuEventEmitter.emit(false);
  }

  ngOnInit(): void {
    this.getPrivacyPolicy();
  }

  getPrivacyPolicy() {
    let Id = localStorage.getItem('languageId');
    if (Id != null) {
      this.LanguageId = parseInt(Id);
    }
    let language = localStorage.getItem('language');
    if (language != null) {
      this.CountryCode = language;
    }
    this.apiService.getPrivacyPolicy(this.LanguageId, this.CountryCode).subscribe((response) => {
      if (response) {
        this.PolicyPrivacyText = this.sanitizer.bypassSecurityTrustHtml(this.customStyle + response.textContent);
      }
    });
  }
}
